export class Table {
    constructor(
        public id?:number,
        public name:string = null,
        public maxSize:number = null,
        public turnAroundTime:number = null
    ){}
}